import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./VerificationsCategory.scss";
import _ from "lodash";
import Helmet from "react-helmet";
import {config} from "../../../../config";
import {fetchCategory, resetCategory} from "../../../../creators/category";
import VerificationsPhoto from "./VerificationsPhoto";



class TagModerationVerificationCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.categoryId = _.get(this.props, "match.params.categoryId") || null;
        this.goBackUrl = _.get(this.props, "match.url").replace(`-photo/${this.categoryId}`, "") || "/";
        this.props.fetchCategory(this.categoryId);
    }

    componentWillUnmount() {
        this.props.resetCategory();
    }

    render() {
        let currentCategories = [];
        let isCategoryIa = false;
        if(this.props.categoryInitialized){
            currentCategories = Array.isArray(this.props.category.parents) && this.props.category.parents.map(parent => parent.title);
            currentCategories.push(`"${this.props.category.title}"`)
            let parentSlug = _.get(this.props.category,'parents[0].slug');
            isCategoryIa = ['temperature', 'genre'].includes(parentSlug);
        }

        return (
            <div id="tag-moderations-verification-category">
                <Helmet>
                    <title>{config.preTitle} Tag Moderations {config.postTitle}</title>
                </Helmet>

                <div className={"container"}>
                    <div className="card">
                        {this.props.categoryInitialized ? <VerificationsPhoto isCategoryIa={isCategoryIa} goBackUrl={this.goBackUrl} currentCategory={this.props.category} /> : null}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        category: state.category.data,
        categoryInitialized : state.category.initialized,
        categoryLoading : state.category.loading,

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategory,
    resetCategory
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagModerationVerificationCategory);